import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold mb-3">
              专题合集
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热门PK专题索引
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-[600px] mx-auto">
              分类浏览你最感兴趣的娱乐PK话题，每个专题都有新鲜热乎的投票等着你
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {indexData.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className="group relative bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline flex flex-col"
              >
                <div className="flex items-start justify-between mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs font-medium">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="flex items-center gap-1 text-accent-500 text-xs font-semibold">
                      <i className="ri-fire-line text-xs"></i>
                      热
                    </span>
                  )}
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="mt-auto flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.count}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}